import { DropdownButton } from "../../../ui/Dropdown";
import { Icon } from "../../../ui/Icon";
import { Surface } from "../../../ui/Surface";
import { Toolbar } from "../../../ui/Toolbar";
import { Popover } from "../../../ui/Popover";

const FONT_SIZES = [
    { label: "Smaller", value: "12px" },
    { label: "Small", value: "14px" },
    { label: "Medium", value: "" },
    { label: "Large", value: "18px" },
    { label: "Extra Large", value: "24px" },
];

export type FontSizePickerProps = {
    onChange: (value: string) => void;
    value: string;
};

export const FontSizePicker = ({ onChange, value }: FontSizePickerProps) => {
    const currentValue = FONT_SIZES.find(size => size.value === value);
    const currentSizeLabel = currentValue?.label.split(" ")[0] || "Medium";

    return (
        <Popover
            content={({ closePopup }) => (
                <Surface
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                        padding: "16px 8px",
                    }}>
                    {FONT_SIZES.map(size => (
                        <DropdownButton
                            isActive={value === size.value}
                            onClick={() => {
                                onChange(size.value);
                                closePopup();
                            }}
                            key={`${size.label}_${size.value}`}>
                            <span
                                style={{ fontSize: size.value }}
                                data-testid="auto-id-7e0d389d-42c2-4357-b037-2265b9f02c8b">
                                {size.label}
                            </span>
                        </DropdownButton>
                    ))}
                </Surface>
            )}>
            {({ openPopup }) => (
                <Toolbar.Button active={!!currentValue?.value} onClick={openPopup}>
                    {currentSizeLabel}
                    <Icon name="ChevronDown" style={{ width: "8px", height: "8px" }} />
                </Toolbar.Button>
            )}
        </Popover>
    );
};
